import StarRateIcon from "@mui/icons-material/StarRate"
import Rating from "@mui/material/Rating"
import { styled } from "@mui/material/styles"

import Row from "../../../common/components/Row"

export default function RatingStars({ candidate, width = "20px" }) {
  const rating = candidate.rating || 0
  const filledStars = Math.ceil(rating / 2)
  const emptyStars = 5 - filledStars

  return (
    <Row title={rating}>
      {new Array(filledStars).fill(null).map((x, i) => (
        <FilledRatingStar key={i} sx={{ width }} />
      ))}
      {new Array(emptyStars).fill(null).map((x, i) => (
        <EmptyRatingStar key={i} sx={{ width }} />
      ))}
    </Row>
  )
}

export function RatingEditor({ rating, setRating, readOnly = false }) {
  return (
    <Rating
      readOnly={readOnly}
      value={Math.ceil(rating / 2)}
      onChange={(e, newValue) => setRating(e, newValue * 2)}
      icon={<FilledRatingStar />}
      emptyIcon={<EmptyRatingStar />}
      precision={1}
    />
  )
}

const BaseRatingStar = styled(StarRateIcon)(() => ({
  width: "20px",
}))

export const FilledRatingStar = styled(BaseRatingStar)(({ theme }) => ({
  fill: theme.palette.colors.brand400,
}))

export const EmptyRatingStar = styled(BaseRatingStar)(({ theme }) => ({
  fill: theme.palette.colors.gray300,
}))
